/**
 * SenderIdManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RequestForm } from './requestForm';
import { SenderIdRequestStatus } from './senderIdRequestStatus';
import { SenderIdType } from './senderIdType';

export interface SenderIdRequestProcessingModel { 
    id?: string;
    authorizationLetterSource?: string;
    serviceProviderName?: string;
    aggregatorName?: string;
    serviceOwner?: string;
    processingPartnerId?: string;
    serviceProviderId?: string;
    contactEmailAddress?: string;
    senderId?: string;
    senderIdType?: SenderIdType;
    request?: RequestForm;
    adminComments?: string;
    aggregatorStatus?: SenderIdRequestStatus;
    status?: SenderIdRequestStatus;
    regulatorStatus?: SenderIdRequestStatus;
    processingPartnerStatus?: SenderIdRequestStatus;
    approvedBy?: string;
    activatedBy?: string;
    revokedBy?: string;
    declinedBy?: string;
    dateCreated?: Date;
    dateUpdated?: Date;
    dateApproved?: Date;
    dateActivated?: Date;
    dateRevoke?: Date;
    dateDeclined?: Date;
    dateBlock?: Date;
    aggregatorId?: string;
    tenantId?: string;
}